import { changeToCtOrder, completeOrder, judeExitCtOrder, cancelCtOrder, getOrderDetail, calcYbTcDoseNum } from '@/api/order'
import { callNumberListApi, callNumberApi, overNumberedApi, restartCallApi } from '@/api/callNumber'

class orderDTO {
    /**
     * 生产订单
     * params 就诊单号 原价 总价
     */
    static createOrder(params) {
        return new Promise((resolve, reject) => {
            changeToCtOrder(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 完成订单
     * params 就诊id
     */
    static completeOrder(params) {
        return new Promise((resolve, reject) => {
            completeOrder(params).then(res => {
                resolve(res)
            })
        })
    }

    /**
     * 判断是否存在有效订单
     * params 就诊id
     */
    static judeExitCtOrder(params) {
            return new Promise((resolve, reject) => {
                judeExitCtOrder(params).then(res => {
                    resolve(res)
                })
            })
        }
        /**
         * 取消订单
         * params 就诊id
         */
    static cancelCtOrder(params) {
            return new Promise((resolve, reject) => {
                cancelCtOrder(params).then(res => {
                    resolve(res)
                })
            })
        }
        //叫号列表
    static callNumListDTO(params) {
            return new Promise((resolve, reject) => {
                callNumberListApi(params).then(res => {
                    resolve(res)
                })
            })
        }
        //叫号
    static callNumDTO(params) {
            return new Promise((resolve, reject) => {
                callNumberApi(params).then(res => {
                    resolve(res)
                })
            })
        }
        //过号
    static overNumberedDTO(params) {
            return new Promise((resolve, reject) => {
                overNumberedApi(params).then(res => {
                    resolve(res)
                })
            })
        }
        //重新呼叫
    static restartCallDTO(params) {
            return new Promise((resolve, reject) => {
                restartCallApi(params).then(res => {
                    resolve(res)
                })
            })
        }
        //查询订单明细
    static getOrderDetail(params) {
        return new Promise((resolve, reject) => {
            getOrderDetail(params).then(res => {
                resolve(res)
            })
        })
    }

    //查询可统筹剂量
    static calcYbTcDoseNum(params) {
        return new Promise((resolve, reject) => {
            calcYbTcDoseNum(params).then(res => {
                resolve(res)
            })
        })
    }
}

export { orderDTO }